import { rootRoute, protectedRoute, appRoute } from '@phrmpc/app/routing/parent-routes';
import { authRouteTree } from '@phrmpc/app/routing/auth.routes';
import { errorRoute, notFoundRoute } from '@phrmpc/app/routing/error.routes';
import dashboardRoute from '@phrmpc/app/routing/dashboard.routes';
import deploymentRouteTree from '@phrmpc/app/routing/deployment.routes';
import memberManagementRouteTree from '@phrmpc/app/routing/member-management.routes';
import documentTransmittalRoute from '@phrmpc/app/routing/document-transmittal.routes';
import onlineFormsRoute from '@phrmpc/app/routing/online-forms.routes';
import trainingContentRoute from '@phrmpc/app/routing/training-content.routes';
import incidentManagementRoute from '@phrmpc/app/routing/incident-management.routes';
import userManagementRoute from '@phrmpc/app/routing/user-management.routes';
import { createRoute } from '@tanstack/react-router';
import { PlaceholderPage } from '@phrmpc/shared/components';

export const homeRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: () => <PlaceholderPage title="Home" />,
  staticData: {
    handle: { title: 'Home' },
  },
});

export const routeTree = rootRoute.addChildren([
  authRouteTree,
  protectedRoute.addChildren([
    appRoute.addChildren([
      homeRoute,
      dashboardRoute,
      deploymentRouteTree,
      memberManagementRouteTree,
      documentTransmittalRoute,
      onlineFormsRoute,
      trainingContentRoute,
      incidentManagementRoute,
      userManagementRoute,
    ]),
  ]),
  errorRoute,
  notFoundRoute,
]);
